import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AccessRoleTypes } from '@next/core-lib';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';
import { NavigationActions } from '@next/core-lib/navigation';
import { SiteState } from '@next/core-lib/site';
import { WrapperSiteSidenavComponent } from '@next/core-lib/wrapper-site-sidenav';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [CommonModule, WrapperSiteSidenavComponent, RouterOutlet],
})
export class AppComponent {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly env = inject<AgrEnvironment>(EnvironmentInjector);
  private readonly isGlobalAdministrator = this.store.selectSignal(
    AuthorizationSelectors.hasGlobalAdministratorRoleForApplicationKey(this.env.APPLICATION_KEY),
  );
  private readonly userRole = this.store.selectSignal(
    AuthorizationSelectors.selectUserRoleForApplicationKey(this.env.APPLICATION_KEY),
  );
  private readonly isIntermediary = computed(
    () => this.userRole() === AccessRoleTypes.Intermediary,
  );

  constructor() {
    effect(() => {
      const navigationItems = [
        {
          relativeUrl: '/upload-file',
          label: 'upload.navigation.uploadFile',
          icon: 'file_upload',
        },
      ];

      if (this.isIntermediary() || this.isGlobalAdministrator()) {
        navigationItems.push({
          relativeUrl: '/chain-partner-dashboard',
          label: 'chainPartnerDashboard.navigation',
          icon: 'dashboard',
        });
      }

      if (this.isGlobalAdministrator()) {
        navigationItems.push(
          {
            relativeUrl: '/uploads-overview',
            label: 'uploadsOverview.navigation',
            icon: 'inventory_2',
          },
          {
            relativeUrl: '/concept-yield-values',
            label: 'conceptYieldValues.navigation',
            icon: 'monitoring',
          },
          {
            relativeUrl: '/concepts',
            label: 'concepts.navigation.management',
            icon: 'lightbulb',
          },
          {
            relativeUrl: '/chain-partners',
            label: 'chainPartners.navigation.management',
            icon: 'business',
          },
          {
            relativeUrl: '/quality-properties',
            label: 'qualityProperties.navigation',
            icon: 'science',
          },
        );
      }

      this.store.dispatch(NavigationActions.setNavigationItems({ navigationItems }));
    });
  }
}
